import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const B = '#1A1A1A';
const R = '#DD0000';
const G = '#FFCE00';
const W = '#FFFFFF';
const API_BASE = 'https://deutschbridge-lms-production.up.railway.app';
const PRICES = { A1: '3,550', A2: '3,999', B1: '4,200', B2: '4,500' };
const LEVEL_META = {
  A1: { name: 'Beginner', desc: 'For complete beginners. Start from zero.', weeks: 10 },
  A2: { name: 'Elementary', desc: 'Build on daily conversations.', weeks: 10 },
  B1: { name: 'Intermediate', desc: 'Discuss opinions and work topics.', weeks: 12 },
  B2: { name: 'Upper Intermediate', desc: 'Complex texts and formal writing.', weeks: 14 },
};

export default function EnrollPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', level: 'A1' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [focused, setFocused] = useState('');

  const setF = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError('Please fill in all required fields.');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(form.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/enroll/interest`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || data.message || 'Something went wrong.');
      setSubmitted(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: 'Arial, sans-serif' }}>
        <div style={{ maxWidth: 500, width: '100%', background: W, borderRadius: 16, border: '1px solid #E0E0E0', overflow: 'hidden', boxShadow: '0 4px 32px rgba(0,0,0,0.1)', textAlign: 'center' }}>
          <div style={{ display: 'flex', height: 6 }}>
            <div style={{ flex: 1, background: B }} />
            <div style={{ flex: 1, background: R }} />
            <div style={{ flex: 1, background: G }} />
          </div>
          <div style={{ padding: '40px 32px 36px' }}>
            <div style={{ fontSize: 50, marginBottom: 16 }}>🎉</div>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: B, marginBottom: 10 }}>
              Danke, {form.name.split(' ')[0]}!
            </h2>
            <p style={{ fontSize: 15, lineHeight: 1.65, color: '#555', marginBottom: 20 }}>
              Payment details have been sent to <strong style={{ color: R }}>{form.email}</strong>. Please check your inbox and spam folder.
            </p>
            <div style={{ background: '#F5F5F5', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'left' }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#888', textTransform: 'uppercase', marginBottom: 10 }}>Enrollment Summary</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 14 }}>
                <span style={{ color: '#777' }}>Level</span>
                <span style={{ fontWeight: 700, color: B }}>{form.level} — {LEVEL_META[form.level].name}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 14 }}>
                <span style={{ color: '#777' }}>Course Fee</span>
                <span style={{ fontWeight: 700, color: B }}>GHS {PRICES[form.level]}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                <span style={{ color: '#777' }}>Duration</span>
                <span style={{ fontWeight: 700, color: B }}>{LEVEL_META[form.level].weeks} weeks</span>
              </div>
            </div>
            <p style={{ fontSize: 13, color: '#777', marginBottom: 24 }}>
              Complete your payment and send your receipt to confirm your spot. Your account will be created within 24 hours.
            </p>
            <a href="https://wa.me/233202071417" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: '100%', padding: '14px', borderRadius: 10, background: '#25D366', color: W, textDecoration: 'none', fontSize: 15, fontWeight: 700, boxSizing: 'border-box', marginBottom: 14 }}>
              📱 Send Receipt on WhatsApp
            </a>
            <Link to="/" style={{ display: 'block', textAlign: 'center', fontSize: 13, color: '#888', textDecoration: 'none' }}>
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#F5F5F5', fontFamily: 'Arial, sans-serif' }}>
      <style>{'@keyframes spin { from{transform:rotate(0deg);} to{transform:rotate(360deg);} }'}</style>

      <div style={{ background: B, padding: '0 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: 28, height: 20, borderRadius: 3, overflow: 'hidden' }}>
              <div style={{ flex: 1, background: B }} />
              <div style={{ flex: 1, background: R }} />
              <div style={{ flex: 1, background: G }} />
            </div>
            <span style={{ fontSize: 16, fontWeight: 800, letterSpacing: '-0.3px' }}>
              <span style={{ color: G }}>Deutsch</span><span style={{ color: W }}>Bridge</span>
            </span>
          </Link>
          <Link to="/login" style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>
            Already enrolled? Login →
          </Link>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 20px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>

        <div style={{ flex: '1 1 380px', minWidth: 320 }}>
          <div style={{ background: W, borderRadius: 16, border: '1px solid #E0E0E0', overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
            <div style={{ background: B, padding: '24px 28px' }}>
              <div style={{ display: 'flex', height: 4, marginBottom: 18 }}>
                <div style={{ flex: 1, background: B }} />
                <div style={{ flex: 1, background: R }} />
                <div style={{ flex: 1, background: G }} />
              </div>
              <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: W }}>Register Your Interest</h1>
              <p style={{ margin: '6px 0 0', fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>Get payment details sent to your inbox instantly.</p>
            </div>

            <div style={{ padding: '28px' }}>
              {error && (
                <div style={{ padding: '11px 14px', background: '#FFF2F2', border: '1px solid #FECACA', borderRadius: 10, marginBottom: 18, fontSize: 13, color: '#DC2626' }}>
                  ⚠️ {error}
                </div>
              )}

              {[
                { key: 'name', label: 'Full Name', type: 'text', placeholder: 'e.g. Kwabena Asante', hint: '' },
                { key: 'email', label: 'Email Address', type: 'email', placeholder: 'your@email.com', hint: 'Payment instructions will be sent here.' },
                { key: 'phone', label: 'Phone Number', type: 'text', placeholder: 'e.g. 0244123456', hint: 'For WhatsApp communication.' },
              ].map(field => (
                <div key={field.key} style={{ marginBottom: 18 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 700, color: B, marginBottom: 6 }}>
                    {field.label} <span style={{ color: R }}>*</span>
                  </label>
                  <input
                    type={field.type}
                    value={form[field.key]}
                    onChange={e => setF(field.key, e.target.value)}
                    placeholder={field.placeholder}
                    onFocus={() => setFocused(field.key)}
                    onBlur={() => setFocused('')}
                    style={{ width: '100%', padding: '12px 14px', fontSize: 14, border: `2px solid ${focused === field.key ? R : '#E0E0E0'}`, borderRadius: 10, outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s' }}
                  />
                  {field.hint && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#888' }}>{field.hint}</p>}
                </div>
              ))}

              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 700, color: B, marginBottom: 8 }}>
                  Level <span style={{ color: R }}>*</span>
                </label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {Object.entries(LEVEL_META).map(([lv, info]) => (
                    <button key={lv} type="button" onClick={() => setF('level', lv)} style={{ padding: '12px', border: `2px solid ${form.level === lv ? R : '#E0E0E0'}`, borderRadius: 10, background: form.level === lv ? '#FFF2F2' : W, cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                        <span style={{ display: 'inline-block', padding: '2px 8px', background: form.level === lv ? R : '#F0F0F0', color: form.level === lv ? W : '#555', borderRadius: 5, fontSize: 12, fontWeight: 800 }}>{lv}</span>
                        <span style={{ fontSize: 12, fontWeight: 600, color: form.level === lv ? R : B }}>{info.name}</span>
                      </div>
                      <p style={{ margin: 0, fontSize: 11, color: '#888', lineHeight: 1.4 }}>{info.desc}</p>
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ padding: '14px 16px', background: '#FFFBEB', border: `1px solid ${G}`, borderRadius: 10, marginBottom: 22, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{ margin: 0, fontSize: 12, color: '#888', fontWeight: 600 }}>Course Fee</p>
                  <p style={{ margin: '2px 0 0', fontSize: 20, fontWeight: 800, color: B }}>GHS {PRICES[form.level]}</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{LEVEL_META[form.level].weeks} weeks</p>
                  <p style={{ margin: '2px 0 0', fontSize: 12, color: '#555' }}>Level {form.level}</p>
                </div>
              </div>

              <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '14px', background: loading ? '#ccc' : R, color: W, border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, minHeight: 50 }}>
                {loading ? 'Sending Payment Details…' : '📧 Get Payment Details'}
              </button>

              <p style={{ textAlign: 'center', marginTop: 14, fontSize: 12, color: '#aaa' }}>
                No account created. Payment details sent by email only.
              </p>
            </div>
          </div>
        </div>

        <div style={{ flex: '1 1 300px', minWidth: 260 }}>
          <div style={{ background: W, borderRadius: 16, border: '1px solid #E0E0E0', padding: '24px', marginBottom: 20 }}>
            <h3 style={{ fontSize: 15, fontWeight: 700, color: B, marginBottom: 16 }}>What happens next?</h3>
            {[
              { n: '1', text: 'You receive payment instructions by email immediately.' },
              { n: '2', text: 'Pay via bank transfer. Use your name as reference.' },
              { n: '3', text: 'Send payment receipt on WhatsApp to 0202071417.' },
              { n: '4', text: 'We create your account and send login details within 24 hours.' },
            ].map(s => (
              <div key={s.n} style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', flexShrink: 0, background: R, color: W, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800 }}>
                  {s.n}
                </div>
                <p style={{ margin: 0, fontSize: 13, color: '#555', lineHeight: 1.55, paddingTop: 4 }}>{s.text}</p>
              </div>
            ))}
          </div>

          <div style={{ background: B, borderRadius: 16, padding: '24px', marginBottom: 20 }}>
            <h3 style={{ fontSize: 14, fontWeight: 700, color: G, marginBottom: 16 }}>Payment Details</h3>
            {[
              ['Bank', 'Access Bank Ghana'],
              ['Account Name', 'Emmanuel Antwi Boasiako'],
              ['Account Number', '1019000003490'],
              ['Amount', `GHS ${PRICES[form.level]}`],
              ['Reference', `${form.name || '[Your Name]'} ${form.level}`],
            ].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>{k}</span>
                <span style={{ fontSize: 13, color: W, fontWeight: k === 'Account Number' ? 800 : 600 }}>{v}</span>
              </div>
            ))}
            <div style={{ marginTop: 16, padding: '10px 12px', background: 'rgba(221,0,0,0.25)', borderRadius: 8, border: '1px solid rgba(221,0,0,0.4)' }}>
              <p style={{ margin: 0, fontSize: 12, color: '#FF8888', fontWeight: 700 }}>
                ⚠️ After payment, send your receipt via WhatsApp to 0202071417 to confirm.
              </p>
            </div>
          </div>

          <a href="https://wa.me/233202071417" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '14px', borderRadius: 12, background: '#25D366', color: W, textDecoration: 'none', fontSize: 14, fontWeight: 700 }}>
            📱 Chat on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}